<script setup>
const gsapTimeline = useGsapTimeline()
// Steps to reproduce animation:
// 1. Export the animation as a PNG sequence from After Effects
// 2. Use https://www.toptal.com/developers/css/sprite-generator to create a left-to-right sprite from the PNG sequence.
// 3. Use the animated PNG as a mask.

const maskElement = ref(null)

const frames = 21

const start = async () => {
  const originalClasses = maskElement.value.className
  await gsapTimeline({ name: 'EF To Full Bottom Right' })
    .set(maskElement, { className: maskElement.value.className + ' mask-ef-to-full-bottom-right', opacity: 1 })
    .to(maskElement, { maskPosition: '100% 0', duration: frames / 25, ease: `steps(${frames - 1})` })
    .set(maskElement, { className: originalClasses })
}

defineExpose({ start })

const props = defineProps({
  manualStart: { type: Boolean, default: false },
})

onMounted(() => {
  if (!props.manualStart) {
    start()
  }
})
</script>

<template>
  <div ref="maskElement" class="w-full h-full opacity-0">
    <slot />
  </div>
</template>

<style>
.mask-ef-to-full-bottom-right {
  mask: url('~/assets/animations/energetic_frequencies/to_full_bottom_right.png');
}
</style>
